import Vue from 'vue'
import Modal from './Modal'
import Toast from './Toast'
import FabricCollapseDirective from './Collapse/toggleDirective'
import FabricTooltipDirective from './Tooltip/tooltipDirective'

Vue.use(Modal, {})

Vue.use(Toast, {
  timer: 6000,
  position: 'top-right'
})

Vue.directive('fabric-collapse', FabricCollapseDirective)

Vue.directive('fabric-tooltip', FabricTooltipDirective)
